module.exports = __webpack_public_path__ + "4687a62b3da15c724327a15b6b817b49.png";